import { Card, Stack, Typography, LinearProgress } from "@mui/material";

interface Props {
  stats: any;
}

export default function FinancialTrendComparison({ stats }: Props) {
  const income = stats?.totalIncome || 0;
  const expense = stats?.totalExpenditure || 0;
  const ratio = income > 0 ? (expense / income) * 100 : 0;

  return (
    <Card sx={{ p: 3 }}>
      <Stack spacing={2}>
        <Typography variant="h6">
          Financial Trend Comparison
        </Typography>

        <Stack direction="row" justifyContent="space-between">
          <Typography>Total Income</Typography>
          <Typography>{income.toLocaleString()}</Typography>
        </Stack>

        <Stack direction="row" justifyContent="space-between">
          <Typography>Total Expenditure</Typography>
          <Typography>{expense.toLocaleString()}</Typography>
        </Stack>

        <LinearProgress
          variant="determinate"
          value={Math.min(ratio, 100)}
          sx={{ height: 8, borderRadius: 1 }}
        />

        <Typography variant="body2">
          Expenses are {ratio.toFixed(1)}% of total income.
        </Typography>
      </Stack>
    </Card>
  );
}